import React from 'react'

import { useColor } from '../../../kiti/components/theme/_hooks/colors'
import { useElementStyle } from './styles'
import BlockPlugin from './BlockPlugin'

const Element = ({ children, attributes, ...props }) => {
  const color = useColor('light2')
  const style = {
    ...useElementStyle(props.element),
    paddingLeft: 8,
    paddingTop: 3,
    paddingBottom: 3,
    marginTop: 3,
    marginBottom: 3,
    borderLeft: `solid 3px ${color}`,
    fontStyle: 'italic',
    color: color
  }

  return (
    <div style={style} {...attributes}>
      {children}
    </div>
  )
}

const ToggleIcon = props => <BlockPlugin.ToggleIcon icon="RiDoubleQuotesL" name="quote" {...props} />

const QuotePlugin = {
  ...BlockPlugin,
  ToggleIcon,
  Element
}

export default QuotePlugin
